import React from "react";
const ProfileLaterIcon = ({ latter = "XY", colorCode = "#d19c08" }) => {
  return (
    <div
      style={{
        width: "35px",
        height: "35px",
        background: colorCode,
      }}
      className="  rounded-circle d-flex justify-content-center align-items-center"
    >
      <span className="text-white text-uppercase">{latter}</span>
    </div>
  );
};

export default ProfileLaterIcon;
